import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';import { Router } from '@angular/router';
import { ApiService } from "./api.service";
import { Mappings } from "../../shared/mapping";

@Injectable()
export class MessagesService {

    constructor
    (
        protected router: Router,
        protected _api: ApiService,
        protected mappings: Mappings
    ) {}

    setMessagesAsRead(params) 
    {
        let url = this.mappings.Web_Api_Get_Client_Area_Messages;
        
        return this._api.post(url, params);
    }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/messages.service.ts